import { ROUTES } from '../constants';

/**
 * Build a login URL that redirects back to the given path after authentication.
 */
export const loginWithRedirect = (currentPath: string): string =>
  `${ROUTES.LOGIN}?redirect=${encodeURIComponent(currentPath)}`;
